import React from 'react';

interface IQuestionFillProps {
    size?: number;
}

export const QuestionFill: React.FC<IQuestionFillProps> = ({ size = 30 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z"
                fill="#64469E"/>
            <path
                d="M10.926 10.8C11.2551 9.86434 11.9048 9.07535 12.7599 8.57279C13.6151 8.07022 14.6205 7.88651 15.598 8.0542C16.5756 8.22188 17.4623 8.73013 18.1011 9.48894C18.7399 10.2477 19.0895 11.2081 19.088 12.2C19.088 15 14.888 16.4 14.888 16.4M15 22H15.014M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z"
                stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
};